import React, { useState, useEffect } from "react";
import { Form, Button, InputGroup, FormFloating } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { resetPasswordUser } from "../../../redux/slices/userSlice";

import AuthenticationLayout from "../../../components/UI/AuthenticationLayout/AuthenticationLayout";
import FormAlert from "../../../components/UI/FormAlert/FormAlert";
import ButtonTimer from "../../../components/UI/ButtonTimer/ButtonTimer";
import "../../../assets/css/forms.css";

const SUBMIT_TIME_IN_SECONDS = 20;

function PasswordResetScreen() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [submitTimer, setSubmitTimer] = useState(0);

  const [email, setEmail] = useState("");

  const dispatch = useDispatch();
  const userSlice = useSelector((state) => state.userSlice);

  const handleSubmit = async (event) => {
    event.preventDefault();
    dispatch(resetPasswordUser({ email }));
    setIsSubmitted(true);
    setSubmitTimer(SUBMIT_TIME_IN_SECONDS);
  };

  useEffect(() => {
    const timer = submitTimer > 0 && setInterval(() => setSubmitTimer(submitTimer - 1), 1000);
    return () => clearInterval(timer);
  }, [submitTimer]);

  return (
    <>
      <Helmet>
        <title>Recuperar Senha</title>
        <link rel="stylesheet" href="/bootstrap.alt.css" />
      </Helmet>

      <AuthenticationLayout>
        <div className="authentication-form">
          <h4>Recuperar Senha:</h4>

          <Form onSubmit={handleSubmit}>
            {isSubmitted ? (
              <>
                <p>
                  Um link foi enviado para o seu email:
                  <br />
                  <strong>{email}</strong>
                  <br />
                  Dê uma olhada na sua caixa de spam, caso não tenha recebido.
                </p>

                <ButtonTimer type="submit" timerValue={submitTimer}>
                  Enviar outro link por e-mail
                </ButtonTimer>
              </>
            ) : (
              <>
                <Form.Group controlId="collaboratorEmail" className="mb-3">
                  <FormFloating>
                    <Form.Label>E-mail para recuperação</Form.Label>
                    <InputGroup>
                      <Form.Control
                        required
                        placeholder="E-mail para recuperação"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </InputGroup>
                  </FormFloating>
                </Form.Group>

                <Button type="submit">Enviar link por e-mail</Button>
              </>
            )}

            <Link className="hiperlink" to="/">
              Voltar para o login
            </Link>
          </Form>
        </div>

        {userSlice.error && <FormAlert alertTextList={userSlice.error} />}
      </AuthenticationLayout>
    </>
  );
}

export default PasswordResetScreen;
